<template>
  <v-row class="ma-0">
    <v-col cols="12" class="wsp-wallpaper pb-5">
      <div class="ma-2">
        <v-card class="pa-3">
          <div v-if="message.file_id && getFilesMap[message.file_id]">
            <div v-if="getFilesMap[message.file_id].type === 'image'">
              <img :src="getFilesMap[message.file_id].url" width="100%" />
            </div>
            <div v-else class="pa-2 text-caption text--lighten-2" :style="{ 'background-color': '#eee' }">
              <v-icon size="x-small" class="mr-2">fa fa-file</v-icon>
              <span>{{ getFilesMap[message.file_id].name }}</span>
            </div>
          </div>
          <div v-else-if="message.file && message.file.type === 'image'">
            <img :src="message.file.url" width="100%" />
          </div>

          <div class="font-weight-bold text-body-1 pb-1" v-html="renderedText(message.title)"></div>

          <div class="text-body-2 mb-0" v-html="renderedText(message.content)"></div>

          <template v-if="message.type === 'form'">
            <div v-for="(schem, i) in message.schema" :key="i" class="text-body-2">- {{ schem.label }}</div>
          </template>

          <v-col cols="12" class="pa-0 text-caption text--secondary text-right">
            <span>07:42</span>
          </v-col>
        </v-card>
        <div v-if="message.options">
          <template v-if="message.options.length > 3">
            <v-btn block color="white" class="mt-2 info--text" @click="showListOptions">
              <v-icon x-small color="info" class="mr-1"> fas fa-bars</v-icon>
              Ver opciones
            </v-btn>
          </template>
          <template v-if="message.options.length <= 3">
            <div v-for="(button, buttonIndex) in message.options" :key="buttonIndex">
              <v-btn block color="white" class="mt-2 info--text">
                {{ button.title }}
              </v-btn>
            </div>
          </template>
        </div>
      </div>
      <!-- <div class="dialog-area"> -->
      <DialogComponent v-if="show" :message="message" @closeDialog="showListOptions" />
      <!-- </div> -->
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import marked from "marked";
import DialogComponent from "@/views/channels/whatsapp/assistant/components/DialogComponent";

export default {
  name: "WhatsAppMessagePreview",
  components: { DialogComponent },
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters(["getFilesMap"]),
  },
  methods: {
    renderedText(inputText) {
      if (!inputText) return inputText;

      let html = marked(inputText);
      html = html.replace(/<\/?p>/g, "");
      return html;
    },
    showListOptions() {
      this.show = !this.show;
    },
  },
};
</script>

<style>
.wsp-wallpaper {
  background-color: #e5ddd5;
  position: relative;
}

.wsp-wallpaper::before {
  background-image: url("https://storage.googleapis.com/wegrou-assets-dev/assets/wsp-wallpaper.png");
  opacity: 0.08;
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>
